import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

/**
 * Возвращает контекст темы.
 * @return {ThemeProviderContext}
 */
export var useThemeContext = function useThemeContext() {
  return useContext(ThemeContext) || {};
};